import { render, staticRenderFns } from "./UserCharts.vue?vue&type=template&id=c2bff988&scoped=true&"
import script from "./UserCharts.vue?vue&type=script&lang=js&"
export * from "./UserCharts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2bff988",
  null
  
)

export default component.exports